module.exports = __webpack_public_path__ + "img/undraw_informed_decision_p2lh.ca1fd03b.svg";